<template>
  <div id="app">
    <!--    <index-page></index-page>-->
    <!-- <transition :name="$route.meta.transtionName ||'slide-right'"> -->
    <router-view></router-view>
    <!-- </transition> -->
  </div>
</template>

<script>
// import IndexPage from '@/pages/IndexPage'

export default {
  name: 'app',
  components: {
    // IndexPage
  }
}
</script>

<style lang="scss">
@import 'assets/css/index.scss';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

.slide-right-enter-active {
  animation: slideInRight 0.3s;
}

.slide-right-leave-active {
  animation: slideOutRight 0.3s;
}

.slide-down-enter-active {
  animation: slideInUp 0.3s;
}

.slide-down-leave-active {
  animation: slideOutDown 0.3s;
}

@keyframes slideInRight {
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(100%, 0, 0);
  }
}

@keyframes slideInUp {
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue